import { useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { workQGetTotals } from "../../../../lib/fetchApi";
import { setBodyOnWorkQ } from "../../../../lib/workQ";
import Button from "../../../common/Button";
import { notificationActions } from "../../../../store/notifications";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import { formatCurrency } from "../../../../lib/script";
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";
import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3";
import classes from './WorkQTotals.module.css'

export default function WorkQTotals({workq, inMenu, closeHamburgerMenuHandler}) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(null)

    let userPermissionDisabled = useUserTabEditPermissionDisabled('work_queues_totals')

    const selectedFilters = useSelector(state => state.filter.filters)
    const selectedExceptions = useSelector(state => state.filter.exceptions)
    const savedView = useSelector(state => state.filter.savedViewsBySlug?.[workq?.slug] || null)
    const initialLoadWorkq = useSelector(state => state.workqueue.initialLoad)
    const user = useSelector(state => state.user.user)

    const userToken = useSelector(state => state.user.token)

    function clsoeModalHandler() {
        setShowModal(null)
    }

    async function calculateWorkQTotalsHandler() {
        setLoading(true)

        const reqBody = setBodyOnWorkQ(
            workq,
            workq.slug,
            initialLoadWorkq,
            selectedFilters,
            selectedExceptions,
            user,
            null,
            null,
            savedView,
            null,
        )

        let totals = await workQGetTotals(userToken, workq.slug, reqBody)

        if (totals && totals.errorMessage) {
            dispatch(notificationActions.setError(totals))
        } else {            
            // dispatch(notificationActions.setError({errorMessage: `Work Q data queued successfully`, type: 'success'}))
            setShowModal(totals)
            // if (closeHamburgerMenuHandler) {
            //     closeHamburgerMenuHandler()
            // }
        }  

        setLoading(false)
    }

    return <>
        {userPermissionDisabled && <>
        
            {!inMenu && <BodySimpleModalV3 message={'Totals'}>
                <Button click={calculateWorkQTotalsHandler} isLoading={loading}>
                    <i className="ti ti-zoom"></i>  
                </Button>    
            </BodySimpleModalV3>}
            {inMenu && <>
                <button onClick={calculateWorkQTotalsHandler} className={classes.get_totals_button}>
                    {loading ? <span className="loader dark"></span> : <i className="ti ti-zoom"></i>} Get totals
                </button>
            </>}
        </>}
        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={clsoeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper modalTitle={`Totals for ${workq.name}`} closeModal={clsoeModalHandler} widthAuto={true}>
                        <PannelBody>
                           <p>Record Count: {showModal.record_count}</p>
                           <p>Total Balances: ${formatCurrency(showModal.total_balances)}</p>
                           <p>Total Charges: ${formatCurrency(showModal.total_charges)}</p>
                        </PannelBody>
                            

                        <PannelBody>
                            <Button click={clsoeModalHandler} isLoading={loading}>Close</Button>
                        </PannelBody>
                    </ModalInnerWrapper>
                    
                </Modal>,
                document.getElementById("overlay-root")
            )}                  
        </>}
    </>
}